const normalizeUid = (value) => {
  const uid = String(value || "").trim();
  return uid || "";
};

const pickFirstUid = (...values) => {
  for (const value of values) {
    const uid = normalizeUid(value);
    if (uid) return uid;
  }
  return "";
};

const extractUidFromUrl = (rawUrl) => {
  const text = String(rawUrl || "").trim();
  if (!text) return "";

  try {
    const base =
      typeof window !== "undefined" && window?.location?.origin
        ? window.location.origin
        : "https://www.trekkin.pt";
    const url = new URL(text, base);
    const fromQuery = normalizeUid(url.searchParams.get("uid"));
    if (fromQuery) return fromQuery;
    const fromPath = url.pathname.match(/\/history\/([A-Za-z0-9_-]+)\//i);
    if (fromPath?.[1]) return normalizeUid(fromPath[1]);
  } catch {}

  const queryMatch = text.match(/[?&]uid=([A-Za-z0-9_-]+)/i);
  if (queryMatch?.[1]) return normalizeUid(queryMatch[1]);
  const pathMatch = text.match(/\/history\/([A-Za-z0-9_-]+)\//i);
  if (pathMatch?.[1]) return normalizeUid(pathMatch[1]);
  return "";
};

export const getHistoryEntryUid = (entry) => {
  if (!entry || typeof entry !== "object") return "";
  return pickFirstUid(
    entry.uid,
    entry.userUid,
    entry.ownerUid,
    entry?.cloud?.uid,
    extractUidFromUrl(entry?.cloud?.url),
    extractUidFromUrl(entry?.cloud?.path)
  );
};

export const isHistoryEntryOwnedByUser = (
  entry,
  uid,
  { includeUnowned = false } = {}
) => {
  const currentUid = normalizeUid(uid);
  if (!currentUid) return false;
  const entryUid = getHistoryEntryUid(entry);
  if (!entryUid) return !!includeUnowned;
  return entryUid === currentUid;
};

